import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import { PopularSearchCard } from 'site-modules/new-cars-landing/components/popular-search-card/popular-search-card';
import { parseContentMetadata } from 'site-modules/shared/utils/parse-content-metadata';

const SEARCH_CARD_KEYS = ['compare-title', 'compare-image', 'compare-image-alt', 'compare-url', 'compare-url-text'];

export function PopularSearches({ title: sectionTitle, content, className = '' }) {
  return (
    <div className={classnames('popular-searches', className)}>
      <h2 className="heading-3 mb-1_5">{sectionTitle}</h2>
      <Row>
        {parseContentMetadata(content, SEARCH_CARD_KEYS, 6).map(item => (
          <PopularSearchCard key={item.compareTitle} content={item} className="col-6 col-md-3 col-lg-2" />
        ))}
      </Row>
    </div>
  );
}

PopularSearches.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.shape({}).isRequired,
  className: PropTypes.string,
};
